import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "absolute top-0 left-0 right-0 bottom-0 flex"
};
const _hoisted_2 = {
  class: "w-full h-full"
};
import Left from './components/Left.vue';
import Right from './components/Right.vue';
import Write from './components/Write.vue';
import { WriteApi } from '@/api/ai/write';
import { WriteExample } from '@/views/aip/utils/constants';
import { nextTick, ref } from 'vue';
import { useMessage } from '@/hooks/web/useMessage';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const message = useMessage();
    const writeResult = ref(''); // 写作结果
    const isWriting = ref(false); // 是否正在写作中
    const isPreview = ref(false); // 是否预览
    const abortController = ref(); // // 写作进行中 abort 控制器(控制 stream 写作)
    /** 停止 stream 生成 */
    const stopStream = () => {
      abortController.value?.abort();
      isWriting.value = false;
    };
    /** 执行写作 */
    const writeRef = ref();
    const rightRef = ref();
    const submit = data => {
      abortController.value = new AbortController();
      writeResult.value = '';
      isWriting.value = true;
      isPreview.value = true;
      WriteApi.writeStream({
        data,
        onMessage: async res => {
          const {
            code,
            data,
            msg
          } = JSON.parse(res.data);
          if (code !== 0) {
            message.alert(`写作异常! ${msg}`);
            stopStream();
            return;
          }
          writeResult.value = writeResult.value + data;
          // 滚动到底部
          await nextTick();
          writeRef.value?.scrollToBottom();
        },
        ctrl: abortController.value,
        onClose: stopStream,
        onError: error => {
          console.error('写作异常', error);
          stopStream();
          // 需要抛出异常，禁止重试
          throw error;
        }
      });
    };
    const handleWriteClose = () => {
      isWriting.value = false;
      rightRef.value?.loadWriteList();
      isPreview.value = false;
    };
    /** 点击示例触发 */
    const handleExampleClick = type => {
      writeResult.value = WriteExample[type].data;
    };
    /** 点击重置的时候清空写作的结果**/
    const reset = () => {
      writeResult.value = '';
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(Left, {
        "is-writing": isWriting.value,
        class: "h-full",
        onSubmit: submit,
        onReset: reset,
        onExample: handleExampleClick
      }, null, 8, ["is-writing"]), _createElementVNode("div", _hoisted_2, [isPreview.value ? (_openBlock(), _createBlock(Write, {
        key: 0,
        "is-writing": isWriting.value,
        onStopStream: stopStream,
        onHandleClose: handleWriteClose,
        ref_key: "writeRef",
        ref: writeRef,
        class: "flex-grow",
        content: writeResult.value,
        "onUpdate:content": _cache[0] || (_cache[0] = $event => writeResult.value = $event)
      }, null, 8, ["is-writing", "content"])) : (_openBlock(), _createBlock(Right, {
        key: 1,
        ref_key: "rightRef",
        ref: rightRef,
        class: "flex-grow"
      }, null, 512))])]);
    };
  }
});